import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import MdsDataplaneResources from "@ane/exp-data/lib/resources/MdsDataplaneResource";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import WPSResource from "@ane/exp-data/lib/resources/WPSResource";
import { RestResult } from "@ane/core/lib/services/RestServiceBase";
import Logger from "@ane/core/lib/services/logging/Logger";
import { TelemetryEventName } from "@ane/core/lib/services/MSALAuthService/TelemetryEventName";
import { isUsingWPSWorkspace } from "@ane/core/lib/utils/WPSUtils";
const actionPrefix = "USER_CLAIMS";
const checkExpGroupClaim = {
  actionPrefix: `${actionPrefix}/CHECK_EXPERIMENTATION_GROUP_CLAIM`,
  reduxKeyNested: (inputPayload) => [
    "workspaces",
    inputPayload.workspaceId,
    "experimentationGroupClaims",
    inputPayload.experimentationGroupId,
    inputPayload.claim
  ],
  loadResource: (inputPayload) => {
    var _a, _b, _c;
    Logger.info(`${TelemetryEventName.WPS_User_Access_Check_ExpGroup_Claim}`, {
      needRequestToProxy: (_a = EnvironmentService.getWpsStatus()) == null ? void 0 : _a.needRequestToProxy,
      workspaceProxyEnabled: (_b = EnvironmentService.getWpsStatus()) == null ? void 0 : _b.workspaceProxyEnabled
    });
    if (!isUsingWPSWorkspace()) {
      return MdsDataplaneResources.isAuthorizedRestResult(
        inputPayload.workspaceId,
        inputPayload.experimentationGroupId,
        inputPayload.claim
      );
    } else if ((_c = EnvironmentService.getWpsStatus()) == null ? void 0 : _c.workspaceProxyEnabled) {
      return WPSResource.isAuthorizedRestResult(
        inputPayload.workspaceId,
        inputPayload.experimentationGroupId,
        inputPayload.claim
      );
    } else {
      return new Promise((resolve) => resolve(RestResult.fromResult(false, true)));
    }
  },
  onCompleteSuccess: (resourceResult) => !!resourceResult
};
const checkExpGroupClaimEpicReducer = loadResourcesUtils(checkExpGroupClaim);
const checkWorkspaceClaim = {
  actionPrefix: `${actionPrefix}/CHECK_WORKSPACE_CLAIM`,
  reduxKeyNested: (inputPayload) => ["workspaces", inputPayload.workspaceId, "workspaceClaims", inputPayload.claim],
  loadResource: (inputPayload) => {
    var _a, _b, _c;
    Logger.info(`${TelemetryEventName.WPS_User_Access_Check_Workspace_Claim}`, {
      needRequestToProxy: (_a = EnvironmentService.getWpsStatus()) == null ? void 0 : _a.needRequestToProxy,
      workspaceProxyEnabled: (_b = EnvironmentService.getWpsStatus()) == null ? void 0 : _b.workspaceProxyEnabled
    });
    if (!isUsingWPSWorkspace()) {
      return MdsDataplaneResources.isAuthorizedonEwRestResult(inputPayload.workspaceId, inputPayload.claim);
    } else if ((_c = EnvironmentService.getWpsStatus()) == null ? void 0 : _c.workspaceProxyEnabled) {
      return WPSResource.isAuthorizedonEwRestResult(inputPayload.workspaceId, inputPayload.claim);
    } else {
      return new Promise((resolve) => resolve(RestResult.fromResult(false, true)));
    }
  },
  onCompleteSuccess: (resourceResult) => !!resourceResult
};
const checkWorkspaceClaimEpicReducer = loadResourcesUtils(checkWorkspaceClaim);
export {
  checkExpGroupClaimEpicReducer,
  checkWorkspaceClaimEpicReducer
};
//# sourceMappingURL=UserAccess.ducks.js.map
